function clickApply(applybtn, applyform) {
    let applyButton = document.getElementById(applybtn);
    applyButton.classList.add("d-none")
    let applySection = document.getElementById(applyform);
    applySection.classList.remove('d-none');
}
window.clickApply = clickApply;